// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://rlyzteydydeeianipuqc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJseXp0ZXlkeWRlZWlhbmlwdXFjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA1MzM1NjgsImV4cCI6MjA3NjEwOTU2OH0.dVnPLH61Gw8lUFb8PN6ALJ9wEeKw8byZUSDHYozq3u0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});